// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// PrimeNg
import { EditorModule } from 'primeng/editor';

// Afidium
import { RichTextareaFieldComponent } from './rich-textarea-field.component';
import { FormFieldModule } from '../form-field/form-field.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        EditorModule,
        FormFieldModule,
    ],
    declarations: [
        RichTextareaFieldComponent
    ],
    exports: [
        RichTextareaFieldComponent
    ]
})
export class RichTextareaFieldModule { }
